import { GamePlace, KING_VALUE } from 'constants/cards';
import { SolitaireGame } from 'game/SolitaireGame';
import { MagicItem, MagicPlace } from './magicGroup';
import { Card } from 'components/Card';
import { GameBoardPlace } from 'game/GameBoardPlace';

// The priority of the area for card selection:
// 1. Tableau (hidden cards)
// 2. Wastepile
// 3. Stockpile

export function findKlondikeMagic(game: SolitaireGame) {
    let item: MagicItem | null = null;

    for (let i = 0; i < 3; i++) {
        switch (i) {
            case 0:
                item = checkHint1(game);
                break;
            case 1:
                item = checkHint2(game);
                break;
            case 2:
                item = checkHint3(game);

                break;
        }
        if (item) return item;
    }
    return null;
}

function getCardFromPlace(hiddenCards: Card[], game: SolitaireGame) {
    const validCardsToMove = [] as { priority: number; card: Card; to: GameBoardPlace; targetCard: Card | null }[];
    hiddenCards.forEach((c) => {
        //1. check if King can be move to empty column
        if (c.value === KING_VALUE) {
            const emptyColumn = game.columns.find((c) => c.isEmpty);
            if (emptyColumn) {
                validCardsToMove.push({ priority: 0, card: c, to: emptyColumn, targetCard: null });
            }
        }
        //2. check foundation
        const validFoundation = game.foundations.find((foundation) => foundation.canDropCard([c]));
        if (validFoundation) {
            validCardsToMove.push({ priority: c.value, card: c, to: validFoundation, targetCard: null });
        }

        //3. check if card can be moved to any column
        const validColumn = game.columns.find((column) => column.canDropCards([c]));
        if (validColumn) {
            validCardsToMove.push({ priority: 20, card: c, to: validColumn, targetCard: validColumn.lastCard });
        }
    });
    validCardsToMove.sort((a, b) => a.priority - b.priority);
    if (validCardsToMove.length) {
        return new MagicItem(
            validCardsToMove[0].card,
            validCardsToMove[0].to,
            MagicPlace.AFTER,
            validCardsToMove[0].targetCard
        );
    }
    return null;
}
function checkHint1(game: SolitaireGame) {
    // ==== CHECK 1: Tableau (hidden cards). ====
    // If there is an empty column, MW draws a King.
    // MW select cards for the foundation area (starting with the smaller card).
    // Creating or continuing any sequence in the tableau area.
    const hiddenCards = [] as Card[];
    game.columns.forEach((column) =>
        column.cards.forEach((c) => {
            if (!c.visible) hiddenCards.push(c);
        })
    );
    return getCardFromPlace(hiddenCards, game);
}

function checkHint2(game: SolitaireGame) {
    // ==== CHECK 2: Moving a card from one column to another to uncover a face-down card in the Tableau area. ====
    if (!game.wastePile) return null; //only for type there is always waste pile in Klondike
    const westPileLength = game.wastePile?.length;
    const hiddenCards = game.wastePile.cards.filter((c, i) => i < westPileLength - 1);
    return getCardFromPlace(hiddenCards, game);
}
function checkHint3(game: SolitaireGame) {
    // ==== CHECK 3: Moving a card from one column to another to uncover a face-down card in the Tableau area. ====

    const hiddenCards = game.stockPile.cards;
    return getCardFromPlace(hiddenCards, game);
}
